import { render, staticRenderFns } from "./home-projects.vue?vue&type=template&id=81024720"
import script from "./home-projects.vue?vue&type=script&lang=js"
export * from "./home-projects.vue?vue&type=script&lang=js"
import style0 from "./home-projects.vue?vue&type=style&index=0&id=81024720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports